import React, { useMemo } from 'react';
import { Box, Card, Table, TableToolbar, Text } from '@wix/design-system';
import { SiteIndexProgressDataHooks } from './site-index-progress.data-hooks';
import { renderDocName, renderProgressBar } from './site-index-progress.utilities';
const SiteIndexProgress = _ref => {
  let {
    title,
    data,
    footnote
  } = _ref;
  const columns = useMemo(() => [{
    dataHook: SiteIndexProgressDataHooks.TypeColumn,
    title: 'Type',
    render: row => renderDocName(row.type),
    width: '60%'
  }, {
    dataHook: SiteIndexProgressDataHooks.IndexingProgressColumn,
    align: 'center',
    title: 'Indexed',
    render: row => /*#__PURE__*/React.createElement(Box, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      dataHook: SiteIndexProgressDataHooks.IndexingProgressText
    }, row.indexed, " / ", row.total))
  }, {
    dataHook: SiteIndexProgressDataHooks.StatusColumn,
    align: 'center',
    title: 'Status',
    render: (row, rowIndex) => /*#__PURE__*/React.createElement(Box, {
      align: "center"
    }, renderProgressBar(row.indexed, row.total, rowIndex))
  }], []);
  return /*#__PURE__*/React.createElement(Card, {
    showShadow: true,
    hideOverflow: true
  }, /*#__PURE__*/React.createElement(Card.Content, {
    size: "none"
  }, /*#__PURE__*/React.createElement(TableToolbar, {
    dataHook: SiteIndexProgressDataHooks.SiteIndexProgressTableToolbar
  }, /*#__PURE__*/React.createElement(TableToolbar.Title, {
    dataHook: SiteIndexProgressDataHooks.SiteIndexProgressTableTitle
  }, title)), /*#__PURE__*/React.createElement(Table, {
    skin: "neutral",
    dataHook: SiteIndexProgressDataHooks.SiteIndexProgressTable,
    data: data,
    columns: columns,
    width: "100%"
  })), footnote && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Divider, null), /*#__PURE__*/React.createElement(Box, {
    padding: "16px 24px"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: SiteIndexProgressDataHooks.IndexingTableFootnote,
    size: "tiny"
  }, footnote))));
};
export default SiteIndexProgress;
//# sourceMappingURL=site-index-progress.js.map